import React from "react";

// Custom professional logo for "National & Monitoring System"
// Hex-shield with concentric ping rings + N glyph
export const Logo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-testid="nms-logo"
  >
    <defs>
      <linearGradient id="nms-grad" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="60%" stopColor="#14b8a6" />
        <stop offset="100%" stopColor="#0ea5a4" />
      </linearGradient>
      <linearGradient id="nms-shield" x1="0" y1="0" x2="0" y2="64" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#1e3a5f" />
        <stop offset="100%" stopColor="#0a1628" />
      </linearGradient>
    </defs>
    {/* outer hex shield */}
    <path
      d="M32 2 L58 16 L58 48 L32 62 L6 48 L6 16 Z"
      fill="url(#nms-shield)"
      stroke="url(#nms-grad)"
      strokeWidth="2"
    />
    {/* radar rings */}
    <circle cx="32" cy="32" r="18" stroke="#10b981" strokeOpacity="0.18" strokeWidth="1" />
    <circle cx="32" cy="32" r="12" stroke="#10b981" strokeOpacity="0.32" strokeWidth="1" />
    <circle cx="32" cy="32" r="6" stroke="#10b981" strokeOpacity="0.55" strokeWidth="1" />
    {/* crosshair */}
    <line x1="32" y1="14" x2="32" y2="50" stroke="#14b8a6" strokeOpacity="0.35" strokeWidth="0.6" />
    <line x1="14" y1="32" x2="50" y2="32" stroke="#14b8a6" strokeOpacity="0.35" strokeWidth="0.6" />
    {/* center N glyph */}
    <path
      d="M26 24 L26 40 M26 24 L38 40 M38 24 L38 40"
      stroke="url(#nms-grad)"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* signal blip */}
    <circle cx="32" cy="32" r="2" fill="#10b981" />
  </svg>
);

export default Logo;
